const brands = [
  {
    key: 'kitchenaid',
    href: '/shop/brand/kitchenaid',
    imgFile: 'kitchenaid.png',
    imgAltText: 'Kitchen Aid',
  },
  {
    key: 'deltagiftcard',
    href: '/shop/brand/delta-air-lines',
    imgFile: 'deltagiftcard.png',
    imgAltText: 'Delta Gift Cards',
  },
  {
    key: 'oxo',
    href: '/shop/brand/oxo',
    imgFile: 'oxo.png',
    imgAltText: 'Oxo',
  },
  {
    key: 'crateandbarrel',
    href: '/shop/brand/crate-barrel',
    imgFile: 'crateandbarrel.png',
    imgAltText: 'Crate & Barrel',
  },
  {
    key: 'fiesta',
    href: '/shop/brand/fiesta',
    imgFile: 'fiesta.png',
    imgAltText: 'Fiesta',
  },
  {
    key: 'airbnbgiftcard',
    href: '/shop/brand/airbnb',
    imgFile: 'airbnbgiftcard.png',
    imgAltText: 'Airbnb Gift Card',
  },
  {
    key: 'lecreuset',
    href: '/shop/brand/le-creuset',
    imgFile: 'lecreuset.png',
    imgAltText: 'Le Creuset',
  },
  {
    key: 'cuisinart',
    href: '/shop/brand/cuisinart',
    imgFile: 'cuisinart.png',
    imgAltText: 'Cuisinart',
  },
  {
    key: 'parachute',
    href: '/shop/brand/parachute',
    imgFile: 'parachute.png',
    imgAltText: 'Parachute',
  },
  {
    key: 'samsonite',
    href: '/shop/brand/samsonite',
    imgFile: 'samsonite.png',
    imgAltText: 'Samsonite',
  },
  {
    key: 'sonos',
    href: '/shop/brand/sonos',
    imgFile: 'sonos1.png',
    imgAltText: 'Sonos',
  },
  {
    key: 'katespade',
    href: '/shop/brand/kate-spade',
    imgFile: 'katespade.png',
    imgAltText: 'Kate Spade',
  },
];

export function getBrands(isVariation = false): typeof brands {
  if (!isVariation) return brands;
  const variationBrands = brands.slice();
  // Update Delta arrow color
  variationBrands[1].imgFile = 'deltagiftcard_orange.png';
  return variationBrands;
}

export const getMobileBrands = (isVariation = false): typeof brands => {
  return getBrands(isVariation).slice(0, 4);
};
